function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Button, FormControl, HStack, Heading, Icon, Input, Link, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Select, Spinner, Stack, Switch, Text, Textarea } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { useFormik } from 'formik';
import DashboardLayout from '../layouts/DashboardLayout';
import { useParams } from 'react-router';
import useChannelStore from '@/stores/ChannelStore';
import { getSpamProtectionFilter, updateSpamProtectionFilter } from '@/actions/SpamProtectionActions';
import { useDebouncedCallback } from 'use-debounce';
import SettingsPanel from '../SettingsPanel';
import { WebRoutes } from '@/utils/constants';
import Panel from '../Panel';
import { Helmet } from 'react-helmet';
import useDebouncedCallbackOnChange from '@/hooks/useDebouncedCallbackOnChange';
import BackButton from '../BackButton';
function SpamProtectionFilter(param) {
    var channel = param.channel, filter = param.filter, onUpdate = param.onUpdate, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading;
    var inputRef = React.useRef(null);
    var intl = useIntl();
    var formik = useFormik({
        initialValues: filter,
        validateOnChange: false,
        onSubmit: function(values) {
            return onUpdate(values);
        }
    });
    useDebouncedCallbackOnChange(formik, formik.handleSubmit);
    React.useEffect(function() {
        formik.resetForm({
            values: filter
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter
    ]);
    React.useEffect(function() {
        formik.setSubmitting(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoading
    ]);
    var handleInputFileChange = React.useCallback(function(fieldName, event) {
        var _event_target_files;
        var file = (_event_target_files = event.target.files) === null || _event_target_files === void 0 ? void 0 : _event_target_files[0];
        if (file == null || file.type !== 'text/plain') {
            return;
        }
        var reader = new FileReader();
        reader.addEventListener('load', function() {
            var fileText = reader.result;
            if (typeof fileText !== 'string') {
                return;
            }
            var phrases = fileText.split('\n').map(function(phrase) {
                return phrase.trim();
            }).filter(function(phrase) {
                return phrase.length > 0;
            });
            formik.setFieldValue(fieldName, phrases.join('\n'));
        }, {
            once: true
        });
        reader.readAsText(file);
    }, [
        formik
    ]);
    var _formik_values_message;
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            maxW: 'container.lg'
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: filter._name
            }),
            /*#__PURE__*/ _jsx(BackButton, {
                fallbackParams: WebRoutes.MODERATION,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "71AfYn",
                    defaultMessage: "Chat Moderation"
                })
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "md",
                        children: filter._name
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        color: "textSecondary",
                        children: filter._description
                    })
                ]
            }),
            filter.limit != null ? /*#__PURE__*/ _jsx(FormControl, {
                id: "limit",
                as: Stack,
                spacing: 4,
                children: /*#__PURE__*/ _jsx(SettingsPanel, {
                    heading: intl.formatMessage({
                        id: "Pk/VZO",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Limit "
                            },
                            {
                                type: 1,
                                value: "type"
                            }
                        ]
                    }, {
                        type: filter._type
                    }),
                    description: filter._limitMin == null || filter._limitMin < 15 ? intl.formatMessage({
                        id: "DQB/pm",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "This is the minimum amount of "
                            },
                            {
                                type: 1,
                                value: "type"
                            },
                            {
                                type: 0,
                                value: " required to trigger the filter."
                            }
                        ]
                    }, {
                        type: filter._type
                    }) : intl.formatMessage({
                        id: "VbzIVA",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "This is the minimum percentage of "
                            },
                            {
                                type: 1,
                                value: "type"
                            },
                            {
                                type: 0,
                                value: " allowed before the filter triggers."
                            }
                        ]
                    }, {
                        type: filter._type
                    }),
                    afterElement: /*#__PURE__*/ _jsxs(NumberInput, {
                        max: filter._limitMax,
                        variant: "filled",
                        min: filter._limitMin,
                        value: formik.values.limit,
                        onChange: function(value) {
                            return formik.setFieldValue('limit', parseInt(value, 10));
                        },
                        children: [
                            /*#__PURE__*/ _jsx(NumberInputField, {
                                onBlur: formik.handleBlur,
                                placeholder: "5"
                            }),
                            /*#__PURE__*/ _jsxs(NumberInputStepper, {
                                children: [
                                    /*#__PURE__*/ _jsx(NumberIncrementStepper, {}),
                                    /*#__PURE__*/ _jsx(NumberDecrementStepper, {})
                                ]
                            })
                        ]
                    })
                })
            }) : null,
            filter.blacklist != null ? /*#__PURE__*/ _jsxs(Panel, {
                padding: 4,
                as: FormControl,
                id: "blacklist",
                isRequired: true,
                spacing: 4,
                display: "flex",
                flexDir: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ _jsx(HStack, {
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        children: /*#__PURE__*/ _jsx(Heading, {
                            size: "sm",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "MmslrB",
                                defaultMessage: "Blacklisted Entries"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Textarea, {
                        variant: "filled",
                        value: formik.values.blacklist,
                        onChange: formik.handleChange
                    }),
                    /*#__PURE__*/ _jsxs(HStack, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                color: "textTertiary",
                                fontSize: "sm",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "/8nVKd",
                                    defaultMessage: "Each line is a separate blacklist entry."
                                })
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "link",
                                size: "xs",
                                padding: 0,
                                color: "textLink",
                                onClick: function() {
                                    var _inputRef_current;
                                    return (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.click();
                                },
                                leftIcon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: faUpload
                                }),
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "Xsj+An",
                                    defaultMessage: "Import text file"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Input, {
                        ref: inputRef,
                        display: "none",
                        type: "file",
                        accept: ".txt",
                        onChange: function(event) {
                            return handleInputFileChange('blacklist', event);
                        }
                    })
                ]
            }) : null,
            filter.checkDisplayNames != null ? /*#__PURE__*/ _jsx(FormControl, {
                id: "checkDisplayNames",
                as: Stack,
                spacing: 4,
                children: /*#__PURE__*/ _jsx(SettingsPanel, {
                    heading: intl.formatMessage({
                        id: "ZJkVAT",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Check Display Names"
                            }
                        ]
                    }),
                    description: intl.formatMessage({
                        id: "UqQeBL",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "If enabled, the filter will check the display name of the user."
                            }
                        ]
                    }),
                    afterElement: /*#__PURE__*/ _jsx(Switch, {
                        colorScheme: "primary",
                        isChecked: formik.values.checkDisplayNames,
                        onChange: formik.handleChange
                    })
                })
            }) : null,
            filter.whitelist != null ? /*#__PURE__*/ _jsxs(Panel, {
                padding: 4,
                as: FormControl,
                id: "whitelist",
                isRequired: true,
                spacing: 4,
                display: "flex",
                flexDir: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ _jsx(HStack, {
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        children: /*#__PURE__*/ _jsx(Heading, {
                            size: "sm",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "p2hbWk",
                                defaultMessage: "Whitelisted Entries"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Textarea, {
                        variant: "filled",
                        value: formik.values.whitelist,
                        onChange: formik.handleChange
                    }),
                    /*#__PURE__*/ _jsxs(HStack, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                color: "textTertiary",
                                fontSize: "sm",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "3p1yyS",
                                    defaultMessage: "Each line is a separate whitelist entry."
                                })
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "link",
                                size: "xs",
                                padding: 0,
                                color: "textLink",
                                onClick: function() {
                                    var _inputRef_current;
                                    return (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.click();
                                },
                                leftIcon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: faUpload
                                }),
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "Xsj+An",
                                    defaultMessage: "Import text file"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Input, {
                        ref: inputRef,
                        display: "none",
                        type: "file",
                        accept: ".txt",
                        onChange: function(event) {
                            return handleInputFileChange('whitelist', event);
                        }
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(FormControl, {
                id: "length",
                as: Stack,
                spacing: 4,
                children: /*#__PURE__*/ _jsx(SettingsPanel, {
                    heading: intl.formatMessage({
                        id: "3IlPaM",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Timeout length"
                            }
                        ]
                    }),
                    description: intl.formatMessage({
                        id: "WBWfpu",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "The timeout that is applied after an initial 5-second timeout warning."
                            }
                        ]
                    }),
                    afterElement: /*#__PURE__*/ _jsxs(NumberInput, {
                        variant: "filled",
                        min: 1,
                        max: 86400,
                        value: formik.values.length,
                        onChange: function(value) {
                            return formik.setFieldValue('length', parseInt(value, 10));
                        },
                        children: [
                            /*#__PURE__*/ _jsx(NumberInputField, {
                                onBlur: formik.handleBlur,
                                placeholder: "5"
                            }),
                            /*#__PURE__*/ _jsxs(NumberInputStepper, {
                                children: [
                                    /*#__PURE__*/ _jsx(NumberIncrementStepper, {}),
                                    /*#__PURE__*/ _jsx(NumberDecrementStepper, {})
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(FormControl, {
                id: "exemptUserLevel",
                isRequired: true,
                as: Stack,
                spacing: 4,
                children: /*#__PURE__*/ _jsx(SettingsPanel, {
                    heading: intl.formatMessage({
                        id: "m1gaLD",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Exempt User-Level"
                            }
                        ]
                    }),
                    description: intl.formatMessage({
                        id: "e5r7mk",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Users with this user-level or higher are exempt from this filter."
                            }
                        ]
                    }),
                    afterElement: /*#__PURE__*/ _jsx(Select, {
                        id: "exemptUserLevel",
                        variant: "filled",
                        value: formik.values.exemptUserLevel,
                        onChange: formik.handleChange,
                        width: "auto",
                        children: Object.entries(channel.userLevels).map(function(param) {
                            var _param = _sliced_to_array(param, 2), userlevelKey = _param[0], userLevel = _param[1];
                            return /*#__PURE__*/ _jsx("option", {
                                value: userlevelKey,
                                children: userLevel
                            }, userlevelKey);
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(FormControl, {
                id: "silent",
                as: Stack,
                spacing: 4,
                children: /*#__PURE__*/ _jsx(SettingsPanel, {
                    heading: intl.formatMessage({
                        id: "AnjpvD",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Silent Timeout"
                            }
                        ]
                    }),
                    description: intl.formatMessage({
                        id: "UFIdEQ",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "If enabled, the timeout will be silent and not display a message."
                            }
                        ]
                    }),
                    afterElement: /*#__PURE__*/ _jsx(Switch, {
                        colorScheme: "primary",
                        isChecked: formik.values.silent,
                        onChange: formik.handleChange
                    })
                })
            }),
            filter.silent == null || formik.values.silent ? null : /*#__PURE__*/ _jsx(FormControl, {
                id: "message",
                isRequired: true,
                as: Stack,
                spacing: 4,
                children: /*#__PURE__*/ _jsx(SettingsPanel, {
                    heading: intl.formatMessage({
                        id: "K81FWb",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Timeout message"
                            }
                        ]
                    }),
                    description: intl.formatMessage({
                        id: "5Y63NX",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Enter a custom timeout message, or leave blank for a random message."
                            }
                        ]
                    }),
                    afterElement: /*#__PURE__*/ _jsx(Input, {
                        isDisabled: formik.values.silent,
                        variant: "filled",
                        value: (_formik_values_message = formik.values.message) !== null && _formik_values_message !== void 0 ? _formik_values_message : undefined,
                        onChange: formik.handleChange,
                        placeholder: formik.values.silent ? intl.formatMessage({
                            id: "cM1axi",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "No Response"
                                }
                            ]
                        }) : intl.formatMessage({
                            id: "EZazU7",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Hey "
                                },
                                {
                                    type: 1,
                                    value: "user"
                                },
                                {
                                    type: 0,
                                    value: ", stop spamming!"
                                }
                            ]
                        }, {
                            user: channel.displayName
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSecondary",
                fontSize: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "yvueYK",
                    defaultMessage: "<link>Learn more</link> about the {type} filter.",
                    values: {
                        type: filter._type,
                        link: function(str) {
                            return /*#__PURE__*/ _jsx(Link, {
                                href: filter._docs,
                                isExternal: true,
                                children: str
                            });
                        }
                    }
                })
            })
        ]
    });
}
export default function SpamProtectionFilterComponent() {
    var filterType = useParams().filterType;
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useState = _sliced_to_array(React.useState(null), 2), filter = _React_useState[0], setFilter = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), loading = _React_useState1[0], setLoading = _React_useState1[1];
    React.useEffect(function() {
        if (filterType == null || channel == null) {
            return;
        }
        getSpamProtectionFilter(channel._id, filterType).then(function(filter) {
            var _useChannelStore_getState;
            var currentChannel = (_useChannelStore_getState = useChannelStore.getState()) === null || _useChannelStore_getState === void 0 ? void 0 : _useChannelStore_getState.channel;
            if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel._id) !== channel._id) {
                return;
            }
            setFilter(filter);
        }).finally(function() {
            return setLoading(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel === null || channel === void 0 ? void 0 : channel._id
    ]);
    var updateFilter = useDebouncedCallback(function(newFilter) {
        if (channel == null) {
            return;
        }
        updateSpamProtectionFilter(channel._id, newFilter).then(setFilter).catch(console.error);
    }, 500);
    if (filter == null || channel == null) {
        return /*#__PURE__*/ _jsx(DashboardLayout, {
            containerProps: {
                maxW: 'container.lg'
            },
            children: /*#__PURE__*/ _jsx(Box, {
                display: "grid",
                placeItems: "center",
                height: "100%",
                children: /*#__PURE__*/ _jsx(Spinner, {})
            })
        });
    }
    return /*#__PURE__*/ _jsx(SpamProtectionFilter, {
        channel: channel,
        filter: filter,
        onUpdate: updateFilter,
        isLoading: loading
    });
}
